import Box from "@mui/material/Box";
import Header from "../components/Header";
import GuestHeader from "../components/Guest/GuestHeader";
import GuestPageFooter from "../components/Guest/GuestPageFooter";
import { useLoginSession } from "shared/LoginSession";

const AppLayout = ({ children }) => {
    const { userInfo } = useLoginSession(false);

    return (
        <div className="min-h-screen">
            {!userInfo ? (
                <Box className="flex flex-col h-[100vh] bg-white">
                    <GuestHeader />
                    {children}
                    <GuestPageFooter />
                </Box>
            ) : (
                <>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Header />
                        {children}
                    </Box>
                </>
            )}
        </div>
    );
};

export default AppLayout;
